//import TextBookSortManagePopup from "@/pages/comp/book_order/textbook/popup/multy_modify";
import MultyModifyTextBookArea from "@/pages/comp/book_order/textbook/common/multy_modify";

function TextBookSortManagePopup(props: any) {
  let myProps = {
    book_seq_arr: [],
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };

  return (
    <div>
      <MultyModifyTextBookArea
        book_seq_arr={myProps.book_seq_arr}
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
      ></MultyModifyTextBookArea>
    </div>
  );
};
export default TextBookSortManagePopup;